import React, { useCallback, useEffect, useState } from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { t, use } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
  Checkbox,
  ComboBox,
  DirectionalHint,
  Dropdown,
  SelectableOptionMenuItemType,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import { ClearIcon } from "@fluentui/react-icons-mdl2";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";

const dropDownStyle = {
  dropdown: {
    width: "100%",
  },
  dropdownItemSelected: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
  dropdownItem: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
    color: "white",
  },
};

const ConfigureSupervisorAccess = (props) => {
  const [supervisorCheckBoxClick, setSupervisorCheckBoxClick] = useState([]);
  const [selectedModality, setSelectedModality] = useState(
    props.values.supervisorIdList.map((s) => s.modalityIds)
  );
  const [modalityList, setModalityList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    let mdl = props.modalityList.map((m) => {
      return {
        key: m.id,
        text: m.name,
      };
    });
    setModalityList(mdl);
  }, []);

  useEffect(() => {
    let checkboxClick = props.values.supervisorIdList.map((s) => {
      return s.modalityIds.length != 0;
    });
    setSupervisorCheckBoxClick((prev) => [...prev, ...checkboxClick]);
  }, []);

  const getModalityNames = (modalityIds) => {
    let modalityNames = [];
    modalityNames = props.modalityList
      .filter((m) => modalityIds.includes(m.id))
      .map((modality) => modality.name);
    return modalityNames.length === 0 ? "-" : modalityNames.join(", ");
  };

  useEffect(() => {
    props.values.supervisorIdList.map((s, index) => {
      s.modalityIds = selectedModality[index];
    });
  }, [selectedModality]);

  const handleAllSupervisorCheckBoxClick = useCallback((e, isChecked) => {
    props.setCheckAllSupervisor(!props.checkAllSupervisor);
    var modalityIdList = props.modalityList.map((mod) => mod.id);
    props.supervisorList
      .filter((sup) => !props.selectedSupervisorMap.has(sup.id))
      .map((sup) => {
        props.setSelectedSupervisorMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.set(sup.id, modalityIdList);
          return nextMap;
        });
      });

    if (props.checkAllSupervisor) {
      props.setSelectedSupervisorMap(new Map());
    }
    props.setTabStatusInitialValue(() => {
      const newStatus = { ...props.tabStatusInitialValue };
      newStatus.tab12Status =
        isChecked == true
          ? { value: "Completed", color: "green" }
          : { value: "Info", color: "red" };
      return newStatus;
    });
  });

  const handleSupervisorCheckBoxClick = useCallback(
    (e, isChecked, selection) => {
      if (props.selectedSupervisorMap.has(e) && selection.key == 0) {
        //To handle deselection of firm
        props.setSelectedSupervisorMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.delete(e);
          return nextMap;
        });
        props.setCheckAllSupervisor(false);
      } else {
        // To handle Selection of firm
        var modalityIdList = modalityList.map((mod) => mod.key);
        if (selection.key != 0) {
          // To handle Modality selection
          modalityIdList = props.selectedSupervisorMap.get(e);
          modalityIdList = modalityIdList.filter((mod) => mod != selection.key);
          if (
            selection.selected === true &&
            modalityIdList.indexOf(selection.key) === -1
          ) {
            modalityIdList.push(selection.key); //  To handle modality selection
          }
        }
        props.setSelectedSupervisorMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.set(e, modalityIdList);
          return nextMap;
        });
      }

      props.setTabStatusInitialValue(() => {
        const newStatus = { ...props.tabStatusInitialValue };
        if (isChecked == true) {
          newStatus.tab12Status = { value: "Completed", color: "green" };
        }
        return newStatus;
      });
    }
  );

  const handleClearButton = useCallback((radId) => {
    if (props.selectedSupervisorMap.has(radId)) {
      let modalityIdList = [];
      props.setSelectedSupervisorMap((prevMap) => {
        const nextMap = new Map(prevMap);
        nextMap.set(radId, modalityIdList);
        return nextMap;
      });
    }
  });

  return (
    <>
      <div className="tab-section">
        {props.action === ACTIONS.EDIT && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px"
                }}
              >
                Supervisors
              </p>
            </section>

            {/* SELECT ALL  */}
            {props.supervisorList.length > 0 && (
                <div className="ms-Grid-row" dir="ltr">
                  <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                    <Checkbox
                      label="Select All"
                      onChange={handleAllSupervisorCheckBoxClick}
                      id="all"
                      checked={props.checkAllSupervisor == true}
                    />
                  </div>
              </div>
            )}

            <div className="ms-Grid-row" dir="ltr">
              {props.supervisorList.map((sup, index) => {
                return (
                  <div
                    key={index}
                    className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4"
                  >
                    <div
                      className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        key={sup.id}
                        label={sup.username}
                        name={sup.username}
                        onChange={(e, isChecked) =>
                          handleSupervisorCheckBoxClick(+sup.id, isChecked, {
                            key: 0,
                          })
                        }
                        //checked={props.checkFirm.includes(firm.id)}
                        checked={props.selectedSupervisorMap.has(sup.id)}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder="Select Modality"
                          multiSelect
                          selectedKeys={
                            props.selectedSupervisorMap.get(+sup.id) || []
                          }
                          options={modalityList}
                          disabled={!props.selectedSupervisorMap.has(+sup.id)}
                          onChange={(e, selection) =>
                            handleSupervisorCheckBoxClick(
                              +sup.id,
                              true,
                              selection
                            )
                          }
                          // errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                      <div
                        className="ms-sm12 ms-md8 ms-lg6 ms-xl2 cursor-pointer"
                        onClick={() => handleClearButton(+sup.id)}
                        style={{ paddingLeft: "5px" }}
                      >
                        <CustomToolTipHost content="Clear" id={"tooltip_" + sup.id}>
                          <ClearIcon></ClearIcon>
                        </CustomToolTipHost>
                      </div>
                      {/* <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2">
                      <p>select all</p>
                    </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {props.action === ACTIONS.VIEW && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px",
                }}
              >
                Supervisors
              </p>
            </section>

            {props.selectedSupervisorMap.size == 0 && (
              <>
                {" "}
                <span>No Supervisors configured</span>
              </>
            )}

            <div className="ms-Grid" dir="ltr">
              {props.supervisorList.map((sup) => {
                return (
                  <>
                    {!!props.selectedSupervisorMap.has(sup.id) && (
                      <div className="ms-Grid-row" dir="ltr">
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                          <span style={{wordBreak:"break-word"}}>{sup.username}</span>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4 firm-access-modality-names">
                          <CustomToolTipHost
                            content={getModalityNames(
                              props.selectedSupervisorMap.get(sup.id)
                            )}
                            id={"tooltip_" + sup.id}
                          >
                            {getModalityNames(
                              props.selectedSupervisorMap.get(sup.id)
                            )}
                          </CustomToolTipHost>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigureSupervisorAccess;
